import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton, Tooltip } from "@mui/material";
import "../batchmanagement.css";
import axios from "axios";
import { baseURL } from "../../../http";
import ManageBatchTestSeries from "./ManageBatchTestSeries";

function ManageBatchTestSeriesLandingPage({
  handleManageTestSeriesClose,
  editData,
  SetDataBaseUpdate,
}) {
  const [data, setData] = useState([]);

  //--------------------------------------------------------------------------------
  // fetch the subjects from api
  //--------------------------------------------------------------------------------
  const fetchTestGenInfoname = async () => {
    try {
      const response = await axios.get(`${baseURL}/TestManagement_fetch_all`);

      setData(response.data);
    } catch (error) {
      console.error("Failed to fetch test info, retrying...", error);
      fetchTestGenInfoname();
    }
  };

  useEffect(() => {
    fetchTestGenInfoname();
  }, []);

  return (
    <>
      <div className="createtestgeneralinfoemarionsmalldiv">
        <div className="edit-icon-alignemnt">
          <Tooltip title="Back to Home" arrow>
            <IconButton onClick={handleManageTestSeriesClose}>
              <ArrowBackIcon className="edit-icon-color-and-fontsize-generalinfo" />
            </IconButton>
          </Tooltip>
        </div>

        <div className="fontsizeandweight">
          <div className="icon-and-name-alignment-generalinfo">
            <span className="info-dispaly-font-color">
              Manage Test Series-{editData.BatchName}
            </span>
          </div>
        </div>

        <div className="fontsizeandweight">
          <div className="icon-and-name-alignment-generalinfo">
            {/* <DownloadButton filteredTestData={selectedBatchTest} BatchName={editData.BatchName}/> */}
          </div>
        </div>
      </div>

      {/* ______________Manage batch subjcet api call________________ */}

      <ManageBatchTestSeries
        SetDataBaseUpdate={SetDataBaseUpdate}
        renderRows={data}
        editData={editData}
        handleManageTestSeriesClose={handleManageTestSeriesClose}
      />
    </>
  );
}

export default ManageBatchTestSeriesLandingPage;
